// extracted by mini-css-extract-plugin
export default {"userTypeCard":"user-type-modal_userTypeCard__dJmmm","cardTitle":"user-type-modal_cardTitle__E8wsz"};